'use client';
import { useState, useEffect } from 'react';
import { size } from '@/lib/utils/global-utils';

export const useResizeHook = () => {
    const [windowWidth, setWindowWidth] = useState(0); // Initialize with a default value

    useEffect(() => {
        // Update state only on the client side
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Set initial width and add event listener
        handleResize();
        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const mobile = Number(size.mobileL.slice(0, -2));
    const tablet = Number(size.tablet.slice(0, -2));
    const laptop = Number(size.laptop.slice(0, -2));
    const laptopS = Number(size.laptopS.slice(0, -2));
    const laptopMui = Number(size.laptopMui.slice(0, -2));
    const smMui = Number(size.smMui.slice(0, -2));

    const isMobile = windowWidth < mobile;
    const isTablet = windowWidth >= tablet && windowWidth < laptop;
    const isDesktop = windowWidth >= laptop;
    const lessThanLaptopS = windowWidth <= laptopS;
    const lessThanTablet = windowWidth <= tablet;
    const lessThanMuiMd = windowWidth <= laptopMui;
    const lessThanMuiSm= windowWidth <= smMui;

    return {
        windowWidth,
        isMobile,
        isTablet,
        isDesktop,
        lessThanLaptopS,
        lessThanTablet,
        lessThanMuiMd,
        lessThanMuiSm,
    };
};
